import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { rockefeller } from '../system/environment/Config.json'
import { RootState } from '../store'

const fetchBaseUAuthApiQuery = fetchBaseQuery({
  baseUrl: rockefeller.api.baseurl,
  prepareHeaders: (headers: Headers, api) => {
    const state = api.getState() as RootState
    headers.append('Content-Type', 'application/json; charset=UTF-8;')
    headers.append('cache-control', 'no-cache')

    if (state.app.uAuthAccessToken) {
      headers.append('Authorization', `Bearer ${state.app.uAuthAccessToken}`)
    }

    if (rockefeller.api.version != null && rockefeller.api.version.trim() !== '') {
      headers.append('version', rockefeller.api.version)
    }
    return headers
  }
})

const UAuthBaseApiSlice = createApi({
  reducerPath: '@api/uauth',
  baseQuery: fetchBaseUAuthApiQuery,
  endpoints: () => ({}),
  keepUnusedDataFor: 60 * 60
})

export default UAuthBaseApiSlice
